export default __webpack_public_path__ + "static/media/scheduleMeeting.4a5d0a47.svg";